import api from "../../services/AxiosService";

export const getDepositDetails=(data)=>{
    return api("get","api/account/list",data,null);
};

export const getAllHomeDetails=(data)=>{
    return api("get","api/home/details",data,null);
};

export const getAllDistrictHomeDetails=(data)=>{
    return api("post","api/home/district-details","",data);
};

export const getAllIslandHomeDetails=()=>{
    return api("post","api/home/island-details","",null);
};

export const getAllDivisionalDetails=(data)=>{
    return api ("post","api/home/divisional-details","",data);
};